import { clientRequest } from "./client";

import { ThreadMessagesResponse } from "../types/res";

export const fetchMessages = async ({
  threadId,
  before,
  page = 0,
  perPage = 5
}: {
  threadId: string;
  before?: Date;
  page?: number;
  perPage?: number;
}) => {
  return clientRequest(async client => {
    const thread = client.getMemoryThread({ threadId });

    try {
      const res = await thread.listMessages({
        page,
        perPage,
        orderBy: {
          direction: "DESC",
          field: "createdAt"
        },
        filter: before
          ? {
              dateRange: {
                end: before
              }
            }
          : undefined
      });

      return res as ThreadMessagesResponse;
    } catch (error) {
      return {
        messages: [],
        total: 0,
        page,
        perPage,
        hasMore: false
      };
    }
  });
};
